import React from 'react'
import Common from './../../api/common.jsx'
import Bottom from './../../api/bottom.jsx'
import './download.less'
import download_qr_code_czy from './../../imgs/download_qr_code_czy.png'
import download_qr_code_cgj from './../../imgs/download_qr_code_cgj.png'
export default class Download extends React.Component {
    render() {
        return (<div className='download'>
            <Common history={this.props.history}></Common>
            <div className="banner ">
                <div className="w">
                    <div className="con">
                        <h2><span>彩之云</span> 开启全新的智慧生活</h2>
                        <h5>包揽吃、住、行、玩、游、购，为广大彩生活社区业主提供全方位智慧社区服务。</h5>
                        <div className="bot">
                            <div className="button">
                                <div className="btn1"></div>
                                <div className="btn2"></div>
                            </div>
                            <div className="ewm">
                                <img src={download_qr_code_czy} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="banner1 ">
                <div className="w">
                    <div className="con">
                        <h2><span>彩管家</span> 开启线上办公新方式</h2>
                        <h5>使用彩管家统一管理进行应用管理，让移动办公更智能。</h5>
                        <div className="bot">
                            <div className="button">
                                <div className="btn1"></div>
                                <div className="btn2"></div>
                            </div>
                            <div className="ewm">
                                <img src={download_qr_code_cgj} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Bottom></Bottom>
            {/* 下载 */}
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/pages/download/download.jsx